var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBreakfast = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M15.482 16.594c.398-1.33 1.76-3.33 3.487-3.33h2.062c1.904 0 3.08 1.474 3.213 2.959M23.556 21.717c-.453.93-1.952 1.783-3.556 1.783a4.45 4.45 0 0 1-3.533-1.795"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M28.383 22.064c-.684.82-1.785.947-2.922.703-.805-.173-1.672-.594-1.905-1.05M24.244 16.79a2.19 2.19 0 0 1 1.989-.208l1.654.618c1.282.582 1.472 1.447 1.396 2.515"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M29.283 18.715c.25-.14 2.217.425 2.217 3.675 0 1.606-2.422 1.279-3.118-.327M11.617 22.064c.684.82 1.784.947 2.922.703.805-.173 1.673-.594 1.905-1.05M15.482 16.637a2.2 2.2 0 0 0-1.715-.056l-1.654.618c-1.282.583-1.472 1.448-1.396 2.516"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M10.717 18.715c-.252-.14-2.217.425-2.217 3.675 0 1.606 2.422 1.279 3.118-.327M23.677 21.265l.567-4.476M29.283 19.715l-.586 2.015M16.263 21.265l-.78-4.627M10.717 19.715l.587 2.185"
}))));
export default SvgBreakfast;